import type { ReactNode } from "react";
import { AddIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";

export type EmptyProps = {
  emptyMessage: string;
  emptyDesc?: string;
  addLabel?: string;
  onAdd?: () => void;
  icon?: ReactNode;
};

export function Empty({
  emptyMessage,
  emptyDesc,
  addLabel,
  onAdd,
  icon = null,
}: EmptyProps) {
  return (
    <Flex
      direction={"column"}
      align={"center"}
      justify={"center"}
      h={300}
      gap={6}
      w={"100%"}
    >
      {icon}
      <Box>
        <Heading
          fontSize={"20px"}
          fontWeight={"bold"}
          color={"gray.600"}
          textAlign={"center"}
        >
          {emptyMessage}
        </Heading>
        {emptyDesc ? (
          <Text
            fontWeight={"medium"}
            mt={2}
            color={"gray.600"}
            textAlign={"center"}
          >
            {emptyDesc}
          </Text>
        ) : null}
        {addLabel && (
          <Button leftIcon={<AddIcon />} mt={5} onClick={onAdd}>
            {addLabel}
          </Button>
        )}
      </Box>
    </Flex>
  );
}
